import React from "react";

function Particuliers(props) {
  return (
    <div>
      <h1>Prêts aux particuliers</h1>

      <div>
        <p>
          Vous avez la possibilité d&#8217;emprunter des jeux / jouets pour une
          durée de 4 semaines.
        </p>
        <p>
          L’adhésion à LudoBlue est obligatoire, notamment pour
          la couverture assurantielle, elle est de 30 euros par an pour une
          famille. Ensuite, chaque jeu emprunté sera facturé à 1 euro.
        </p>
        <p>Un chèque de caution non encaissé sera demandé (25€par jeux).</p>
      </div>
      <p>
        Pour les grands jeux en bois : 5 jeux géants maximum par jour : 10 € /
        jeu et caution de 400 € non encaissée.
      </p>
      
    </div>
  );
}

export default Particuliers;
